import { __assign } from 'tslib';
export var assign = __assign;
//# sourceMappingURL=utilities.js.map